import React from 'react';

const HistorySection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Our Rich <span className="text-primary">Heritage</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            A journey that began with vision, grew through dedication, and continues to inspire leadership excellence across generations.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-8">
            <div className="bg-gradient-to-r from-primary/10 to-secondary/10 p-8 rounded-2xl">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">The Beginning (1991)</h3>
              <p className="text-gray-700 leading-relaxed">
                Our story began on October 23rd, 1991, at Bambalapitya Hindu College. What started as a vision 
                to provide leadership opportunities to young people has evolved into one of Sri Lanka's most 
                distinguished Leo clubs, embodying the true spirit of Leoism.
              </p>
            </div>

            <div className="bg-gradient-to-r from-secondary/10 to-primary/10 p-8 rounded-2xl">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Revival & Growth (1999)</h3>
              <p className="text-gray-700 leading-relaxed">
                Under the guidance of Lion Dr. S. Kulendran MJF and the leadership of Leo Janagan, 
                our club was revived with renewed energy and purpose. This marked the beginning of our 
                journey toward excellence, setting the foundation for decades of impactful service.
              </p>
            </div>

            <div className="bg-gradient-to-r from-primary/10 to-secondary/10 p-8 rounded-2xl">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Era of Excellence (2004-Present)</h3>
              <p className="text-gray-700 leading-relaxed">
                The transformative leadership of Leo P.S. Senthuran in 2004/2005 marked our rise to prominence. 
                From an inactive club with few members, we grew to become one of the top clubs in the district, 
                consistently winning awards and recognition at national and international levels.
              </p>
            </div>
          </div>

          <div className="relative">
            <div className="bg-gradient-to-br from-primary to-secondary p-8 rounded-3xl text-white">
              <h3 className="text-3xl font-bold mb-6">Milestones That Define Us</h3>
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="w-3 h-3 bg-white rounded-full mt-2 flex-shrink-0"></div>
                  <div>
                    <h4 className="font-semibold">Multiple District Excellence Awards</h4>
                    <p className="text-white/90 text-sm">Recognized by Lions Clubs International</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-3 h-3 bg-white rounded-full mt-2 flex-shrink-0"></div>
                  <div>
                    <h4 className="font-semibold">Two Leo of the World Recipients</h4>
                    <p className="text-white/90 text-sm">Unprecedented achievement in consecutive years</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-3 h-3 bg-white rounded-full mt-2 flex-shrink-0"></div>
                  <div>
                    <h4 className="font-semibold">Consistent District Champions</h4>
                    <p className="text-white/90 text-sm">Most Outstanding Club multiple times</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-3 h-3 bg-white rounded-full mt-2 flex-shrink-0"></div>
                  <div>
                    <h4 className="font-semibold">500+ Community Projects</h4>
                    <p className="text-white/90 text-sm">Impacting lives across Sri Lanka</p>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Decorative elements */}
            <div className="absolute -top-4 -right-4 w-24 h-24 bg-secondary/20 rounded-full"></div>
            <div className="absolute -bottom-4 -left-4 w-16 h-16 bg-primary/20 rounded-full"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HistorySection;